<template>
<div class="field">
  <label :class="this.$parent.isFieldRequired(this.keyUser) ? 'req': ''">{{ label }}</label>
  <vue-tags-input
    v-model="tag"
    :tags="defaultData"
    :autocomplete-items="autocompleteItems"
    :add-only-from-autocomplete="true"
    placeholder="Добавить пользователя"
    @tags-changed="update"
  />
</div>
</template>

<script>
import VueTagsInput from "@sipec/vue3-tags-input";
import axios from 'axios';

export default {
  name: "SearchTagAutocomlete",
  data() {
    return {
      tag: '',
      tags: [],
      autocompleteItems: [],
      debounce: null,
    };
  },
  props: [
    'defaultData',
    'label',
    'keyUser'
  ],
  components: {
    VueTagsInput
  },
  watch: {
    'tag': 'initItems',
  },
  computed: {
    tagsToDb() {
      return this.tags.map(a=> {
        return a.id
      })
    }
  },
  methods: {
    update(newTags) {
      console.log(newTags);
      this.autocompleteItems = [];
      this.tags = newTags;
      this.$parent.projectCommand[this.keyUser] = this.tagsToDb;
      this.$parent.saveData();
    },
    initItems() {
      if (this.tag.length < 1) return;
      const url = `/user/getAllUsers/${this.tag}`;

      clearTimeout(this.debounce);
      this.debounce = setTimeout(() => {
        axios.get(url).then(response => {
          this.autocompleteItems = response.data.map(a => {
            return { text: a.fio, id: a.id };
          });
        }).catch(() => console.warn('Oh. Something went wrong'));
      }, 600);
    },
  }
}
</script>

<style scoped>

</style>